/**
 * Fixed Header Module
 * Держит хедер всегда закрепленным вверху
 * 
 * @package KateMedia
 */

export function initFixedHeader() {
    const header = document.querySelector('.header');

    if (!header) return;

    header.classList.add('header--fixed');

    const headerPlaceholder = document.createElement('div');
    headerPlaceholder.className = 'header-placeholder';
    header.parentNode.insertBefore(headerPlaceholder, header.nextSibling);

    function updatePlaceholderHeight() {
        headerPlaceholder.style.height = `${header.offsetHeight}px`;
    }

    updatePlaceholderHeight();
    window.addEventListener('resize', updatePlaceholderHeight);
}
